<ng-container *ngIf="vo$ | async; let vo">
	<app-avatar
		*ngIf="!vo.isGroup && vo.avatar"
		[avatar]="vo.avatar" [withTooltip]="true"></app-avatar>
	<mat-icon
		*ngIf="vo.isGroup"
		[svgIcon]="DcIcons.Group"></mat-icon>
</ng-container>
